/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Kind_SocialInputs */

const cs_templates_kind_social = /** @type {(inputs: Templates_Kind_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sociální sítě`)
};

const en_templates_kind_social = /** @type {(inputs: Templates_Kind_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social media`)
};

/**
* | output |
* | --- |
* | "Social media" |
*
* @param {Templates_Kind_SocialInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_kind_social = /** @type {((inputs?: Templates_Kind_SocialInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Kind_SocialInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_kind_social(inputs)
	return cs_templates_kind_social(inputs)
});